import Vue from 'vue';
import exchangeGraph from './exchange-graph/exchange-graph.vue';
import VueApexCharts from 'vue-apexcharts';
import store from '../common/js/vuex/store';
import exchangeGraphStore from '../applications/exchange-graph/exchange-graph-vuex';
if (!store.hasModule(['exchangeGraph'])) {
	store.registerModule('exchangeGraph', exchangeGraphStore);
}

Vue.use(VueApexCharts);

Vue.component('exchange-graph', exchangeGraph);
